import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = ({  }) => {
    const { t } = useTranslation()
    return (
        <div className="Footer">
            <div className="Footer-info">
                <h3>Kontakt</h3>
                <div>{t('Společnost pro dějiny židů v České Republice')}</div>
                <div>{t('E-mail')}: <a href="mailto:bmsj.brno@gmail.com">{t('bmsj.brno@gmail.com')}</a></div>
            </div>
        </div>
    );
}

Footer.propTypes = {
};

export default Footer;
